import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { formatDate } from "../../Common/Utils/dateUtils";
import {
  getAllEnquiriesListData,
  updateEnquiry,
} from "../../../redux/enquiries/action";
import Spinner from "../../Layouts/Spinner";

const Enquires = () => {
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [theUserTicketStatus, setUserTicketStatus] = useState("");
  const [selectedUserTicket, setSelectedUserTicket] = useState({});
  const navigate = useNavigate();
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
  });
  const dispatch = useDispatch();

  const ticketsList = useSelector(
    (state) => state?.reusableSlice?.getAllEnquiries
  );

  useEffect(() => {
    dispatch(getAllEnquiriesListData(params));
  }, [params, dispatch]);

  const updateComponent = (tickt) => {
    // navigate(`/updateenquiry/${tickt.id}`);
    setModal(true);
    setSelectedUserTicket(tickt);
    setUserTicketStatus(() => tickt.status);
  };

  const handleCloseModal = () => {
    setUserTicketStatus("");
    setModal(false);
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setUserTicketStatus(Number(gender));
  };

  const handleSubmit = async () => {
    const data = {
      status: theUserTicketStatus,
      id: selectedUserTicket.id,
    };
    dispatch(updateEnquiry(data, setLoading))
      .then((res) => {
        if (res.data.status) {
          handleCloseModal();
        }
      })
      .catch((e) => console.log(e.message, "status update error"));
  };

  return (
    <div>
      <div className="p-3 ">
        <div className="category-wrapper d-flex justify-content-center flex-column w-100">
          <div className="d-flex justify-content-between align-items-center sub-head">
            <h4>Enquiries List</h4>
          </div>
        </div>
      </div>

      {ticketsList ? (
  <CardBody className="table-sec px-3">
    <table className="table">
      <thead>
        <tr>
          <th scope="col">Sl No</th>
          <th>Name</th>
          <th scope="col">Email</th>
          <th scope="col">Message</th>
          <th scope="col">Status</th>
          <th>Created On</th>
          <th scope="col" style={{ textAlign: "center" }}>
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {ticketsList?.contactus?.length > 0 ? (
          ticketsList.contactus.map((item, index) => (
            <tr key={index}>
              <td>{index + 1 + (params?.page - 1) * 10}</td>
              <td>{item.name}</td>
              <td>{item.email}</td>
              <td>{item.message}</td>
              <td style={{ color: item.status === 1 ? "green" : "red" }}>
                {item.status === 1
                  ? "Resolved"
                  : item.status === 0
                  ? "Not Resolved"
                  : ""}
              </td>
              <td>{formatDate(item.created_on)}</td>
              <td>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ columnGap: "10px" }}
                >
                  <button
                    className="border-button"
                    onClick={() => updateComponent(item)}
                  >
                    <span>Change Status</span>
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" className="text-center">
              No Enquiries Found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </CardBody>
) : (
  <CardBody className="table-sec px-3">
    <div className="text-center">
      <h5>No Enquiries Found</h5>
    </div>
  </CardBody>
)}

      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={ticketsList?.pagination_meta}
      />
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <ModalHeader>Update the Status of Enquiry</ModalHeader>
        <ModalBody>
          <div className="form-group col-md-6">
            <label htmlFor="status">Change Status</label>
            <select
              id="status"
              title="status"
              className="form-control"
              onChange={handleChangeStatus}
              value={theUserTicketStatus}
            >
              <option value="">Select Status</option>
              <option value="1">Resolved</option>
              <option value="0">Not Resolved</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="back-btn" onClick={() => handleCloseModal()}>
            Cancel
          </button>
          <button
            className="submit-btn"
            onClick={() => handleSubmit()}
            style={{ width: "max-content" }}
          >
            {!loading ? "Update" : <Spinner />}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Enquires;
